<app-info-container
  *ngIf="isGeneralApplicationUpdatePage() && !isNewTHPTalent()"
  [subText]="'talent-happy-path.quick-apply.submit-page.welcome-back' | translate"
></app-info-container>


<div class="top-text-container" *ngIf="isNewTHPTalent() || isGeneralApplication">{{"talent-happy-path.quick-apply.submit-page.required-fields" | translate}}</div>
<div class="apply-form default-padding" *ngIf="isNewTHPTalent() || isGeneralApplication">
  <div class="existing-fields existing-email-field">
    <div class="existing-fields-name">{{'talent-happy-path.quick-apply.submit-page.email-address' | translate}}</div>
    <div class="existing-fields-value">{{talent.email}}</div>
  </div>
  <form [formGroup]="profileForm" class="quick-apply-form">
    <mat-form-field style="width: 100%" *ngIf="!isJapanOrder()">
      <mat-label>{{'talent-happy-path.quick-apply.submit-page.firstName' | translate}}</mat-label>
      <input type="text" matInput formControlName="firstName" placeholder="" [maxLength]="30" id="first-name">
    </mat-form-field>
    <mat-form-field style="width: 100%" *ngIf="!isJapanOrder()">
      <mat-label>{{'talent-happy-path.quick-apply.submit-page.lastName' | translate}}</mat-label>
      <input type="text" matInput formControlName="lastName" placeholder="" [maxLength]="40" id="last-name">
    </mat-form-field>
    <mat-form-field style="width: 100%" *ngIf="isJapanOrder()">
      <mat-label>{{'talent-happy-path.quick-apply.submit-page.lastName' | translate}}</mat-label>
      <input type="text" matInput formControlName="lastName" placeholder="" [maxLength]="40" id="last-name">
    </mat-form-field>
    <mat-form-field style="width: 100%" *ngIf="isJapanOrder()">
      <mat-label>{{'talent-happy-path.quick-apply.submit-page.firstName' | translate}}</mat-label>
      <input type="text" matInput formControlName="firstName" placeholder="" [maxLength]="30" id="first-name">
    </mat-form-field>
    <mat-form-field style="width: 100%" class="hide-subscript">
      <mat-label>{{"talent-happy-path.quick-apply.submit-page.phone" | translate}}</mat-label>
      <input type="text" matInput formControlName="phone" placeholder="" id="phone-number">
    </mat-form-field>
    <div class="postal-code-div">
      <app-location-picker *ngIf="isGeneralApplication" [formGroup]="profileForm" [talent]="talent" (countryIdChanged)="onCountryIdChange($event)"></app-location-picker>
    </div>
  </form>
</div>

<div *ngIf="!isNewTHPTalent() && !isGeneralApplication">
  <div class="card-header default-padding">{{"talent-happy-path.quick-apply.submit-page.personal-info" | translate}}
    <span class="person-info-subtext" *ngIf="!isJapanOrder()">{{"talent-happy-path.quick-apply.submit-page.edit-personal-info" | translate}}
      <a style="text-decoration: underline;" [href]="matUrl" target="_blank">{{"talent-happy-path.quick-apply.submit-page.myaquent" | translate}}</a>
    </span>
  </div>
  <div class="existing-fields">
    <span class="existing-fields-name">{{"talent-happy-path.quick-apply.submit-page.email" | translate}}</span>
    <span class="existing-fields-value">{{talent.email}}</span>
  </div>
  <div class="existing-fields">
    <span class="existing-fields-name">{{"talent-happy-path.quick-apply.submit-page.name" | translate}}</span>
    <span class="existing-fields-value" *ngIf="!isJapanOrder()">{{talent.firstName}} {{talent.lastName}}</span>
    <span class="existing-fields-value" *ngIf="isJapanOrder()">{{talent.lastName}} {{talent.firstName}}</span>
  </div>
  <div class="existing-fields">
    <span class="existing-fields-name">{{"talent-happy-path.quick-apply.submit-page.phone" | translate}}</span>
    <span class="existing-fields-value">{{talent.phoneNumber}}</span>
  </div>
</div>

<div class="home-location-container default-padding" *ngIf="!isGeneralApplication">
  <div class="card-header">
    {{"talent-happy-path.quick-apply.submit-page.homeLocation" | translate}}
  </div>
  <app-location-picker [formGroup]="profileForm" [talent]="talent"></app-location-picker>
</div>


<div class="resume-container">
  <app-file-upload (uploadSuccessEvent)="resumeUploadedHandler($event)"
                   (resumeUploadingEvent)="resumeUploadingHandler($event)"
                   [talentId]="talent?.personId"
                   [fileUploadUserType]="fileUploadUserType"
                   [isJapanOrder] = "isJapanOrder()"
                   [isNewTHPTalent] = "isNewTHPTalent()"
                   (fileSelectedEvent)="isJapanOrder() ? onRirekishoResumeUpload($event) : null">
  </app-file-upload>
</div>

<div class="resume-container" *ngIf="isJapanOrder()">
  <app-file-upload (uploadSuccessEvent)="resumeUploadedHandler($event)"
                   (resumeUploadingEvent)="resumeUploadingHandler($event)"
                   [talentId]="talent?.personId"
                   [isNewTHPTalent] = "isNewTHPTalent()"
                   [isJapanOrder]="true"
                   [isOptional]="true"
                   (fileSelectedEvent)="isJapanOrder() ? onKeirekishoResumeUpload($event) : null"
                   [fileUploadUserType]="fileUploadUserType">
  </app-file-upload>
</div>

@if (this.displayCommunicationPreferenceCard) {
  <div class="card-container  default-padding">
    <form [formGroup]="profileForm">
      <mat-label class="card-header">{{"talent-happy-path.quick-apply.submit-page.communication-preferences.label" | translate}}</mat-label>
      @if (this.displayDoubleOptIn) {
        <div class="checkbox-div-container">
          <mat-checkbox id="double-opt-in-checkbox" formControlName="doubleOptIn" class="checkbox checkbox-div-copy"/>
          <span class="checkbox-div-copy" id="double-opt-in-copy">{{"talent-happy-path.quick-apply.submit-page.double-opt-in.copy" | translate}}
          </span>
        </div>
      }

      @if (this.displayCommunicationPreference) {
        <div class="checkbox-div-container" [style.margin-top]="displayDoubleOptIn ? '16px' : '0'">
          <mat-checkbox id="communication-preference-checkbox" formControlName="communicationPreference" class="checkbox checkbox-div-copy"/>
          <span class="checkbox-div-copy" id="communication-preference-copy">{{"talent-happy-path.quick-apply.submit-page.communication-preferences.copy" | translate}}
          </span>
        </div>
      }
    </form>
  </div>
}

<div class="card-container default-padding">
  <div class="section-header-row">
    <h3 class="section-label">{{"talent-happy-path.quick-apply.submit-page.profiles-portfolios" | translate}}</h3>

    <span class="spacer"></span>

    <span class="optional-text">{{"talent-happy-path.quick-apply.submit-page.optional-text" | translate}}</span>
  </div>

  <form [formGroup]="profileForm">
    <div class="section-group">
      <h3 class="section-label">{{ 'talent-happy-path.quick-apply.submit-page.profile' | translate }}</h3>

      <div formArrayName="profileUrls">
        <div *ngFor="let group of profileUrls.controls; let i = index" [formGroupName]="i" class="url-input-wrapper">
          <mat-form-field subscriptSizing="dynamic" class="full-width">
            <mat-label>{{"talent-happy-path.quick-apply.submit-page.professional-profile-placeholder" | translate}}</mat-label>

            <input matInput formControlName="url" [placeholder]="'talent-happy-path.quick-apply.submit-page.professional-profile-placeholder' | translate">

            <button type="button" mat-icon-button matSuffix (click)="removeProfileUrl(i)" *ngIf="profileUrls.length > 1">
              <mat-icon class="delete-icon">delete_outline</mat-icon>
            </button>

            <mat-error class="quick-apply-hint" *ngIf="group.get('url')?.hasError('invalidUrl')">
              {{"talent-happy-path.quick-apply.submit-page.profile-url-invalid" | translate}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="add-action-row">
        <button type="button" mat-button class="add-button" (click)="addProfileUrl()" [disabled]="!canAddMore">
          <mat-icon>add</mat-icon>
          <span>{{ 'talent-happy-path.quick-apply.submit-page.add-profile' | translate }}</span>
        </button>
      </div>
    </div>

    <div class="section-group">
      <h3 class="section-label">{{ 'talent-happy-path.quick-apply.submit-page.portfolio-work' | translate }}</h3>
      <div formArrayName="portfolioUrls">
        <div *ngFor="let group of portfolioUrls.controls; let i = index" [formGroupName]="i" class="portfolio-item-block">
          <mat-form-field class="full-width">
            <mat-label>{{"talent-happy-path.quick-apply.submit-page.portfolio-placeholder" | translate}}</mat-label>
            <input matInput formControlName="url" [placeholder]="'talent-happy-path.quick-apply.submit-page.portfolio-placeholder' | translate">
            <button type="button" mat-icon-button matSuffix (click)="removePortfolioUrl(i)" *ngIf="portfolioUrls.length > 1">
              <mat-icon class="delete-icon">delete_outline</mat-icon>
            </button>

            <mat-error class="quick-apply-hint" *ngIf="group.get('url')?.hasError('invalidUrl')">
              {{"talent-happy-path.quick-apply.submit-page.profile-url-invalid" | translate}}
            </mat-error>
          </mat-form-field>

          <div class="password-field-container" *ngIf="group.get('showPassword').value">
            <mat-form-field subscriptSizing="dynamic" class="full-width blue-underline">
              <mat-label>{{"talent-happy-path.quick-apply.submit-page.password" | translate}}</mat-label>


              <input matInput
                     [type]="group.get('hidePassword')?.value ? 'password' : 'text'"
                     formControlName="password">

              <button type="button" mat-icon-button matSuffix
                      (click)="group.get('hidePassword')?.setValue(!group.get('hidePassword')?.value)">
                <mat-icon>
                  {{ group.get('hidePassword')?.value ? 'visibility_off' : 'visibility' }}
                </mat-icon>
              </button>
              <mat-error *ngIf="group.get('password')?.hasError('maxlength')">
                {{ 'talent-happy-path.quick-apply.submit-page.password-char-limit' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="password-toggle-row">
            <mat-slide-toggle class="password-toggle" color="primary" formControlName="showPassword">password</mat-slide-toggle>
          </div>
        </div>
      </div>

      <div class="add-action-row">
        <button type="button" mat-button class="add-button" (click)="addPortfolioUrl()" [disabled]="!canAddMore">
          <mat-icon>add</mat-icon>
          <span>{{ 'talent-happy-path.quick-apply.submit-page.add-portfolio' | translate }}</span>
        </button>
      </div>
    </div>
  </form>
</div>

<div class="consent-container">
  <form [formGroup]="profileForm">
    <span>{{ (isGeneralApplication ? "talent-happy-path.quick-apply.submit-page.terms.message" : "talent-happy-path.quick-apply.submit-page.terms.copy") | translate }}</span>
    <div class="checkbox-div-container">
      <mat-checkbox formControlName="termsAccepted" id="agree-to-terms-checkbox" class="checkbox"/>
      <span *ngIf = "!isJapanOrder()" class="checkbox-div-copy" id="agree-to-terms-copy">{{"talent-happy-path.quick-apply.submit-page.terms.agree" | translate}}
        <a style="text-decoration: underline;" [href]= "tosUrl" target="_blank">{{"talent-happy-path.quick-apply.submit-page.terms.terms-of-service" | translate}}</a>
      </span>

      <span class="checkbox-div-copy" *ngIf="isJapanOrder()">
        <a style="text-decoration: underline;" [href]="tosUrl" target="_blank">
          {{"talent-happy-path.quick-apply.submit-page.terms.terms-of-service" | translate}}</a>
        <span id="agree-to-terms-copy">{{"talent-happy-path.quick-apply.submit-page.terms.agree" | translate}}</span>
      </span>
    </div>
  </form>
</div>

<mat-card appearance="outlined" class="error-outline error-card" *ngIf="hasSubmitError">
  <div class="error-container">
    <div class="error-header-text">
        <span class="error-image"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 17V15H13V17H11ZM11 7V13H13V7H11Z"
                  fill="#E70608"/>
        </svg>
        </span>
      <span>
          {{"talent-happy-path.quick-apply.submit-page.submit-error-header" | translate}} <br/>
          <span class="error-text">{{"talent-happy-path.quick-apply.submit-page.submit-error-body" | translate}} <a
            href="mailto:questions@aquent.com?subject=Application Submission Error ID {{submitErrorId}}&body=Dear Support Team %0A
I received Error ID: {{submitErrorId}} while attempting to submit my application. " target="_top">questions&#64;aquent.com</a>
        <span>{{"talent-happy-path.quick-apply.submit-page.submit-error-message-reference" | translate}}</span>
        <span
          style="font-weight: 500;">{{"talent-happy-path.quick-apply.submit-page.submit-error-message-id" | translate: {errorId: this.submitErrorId} }}</span>
      </span>
        </span>
    </div>
  </div>
</mat-card>


<div class="submit-button-container button-container">
  <button mat-flat-button id="submit-button"
          color="primary"
          [disabled]="submitCriteriaMet() || disableSubmit"
          (click)="submit(profileForm)"
          class="continue-button single-custom-button">
    @if (disableSubmit) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
    {{ getSubmitButtonText() | translate }}
  }
  </button>
</div>
